<template>
  <el-tooltip :disabled="!tooltip||!tooltipContent" :content="tooltipContent" placement="bottom-end">
    <cargo-advance-select
      ref="company"
      no="company"
      :popper-class="popperClass"
      :disabled="disabled"
      :select-type="selectTypeNames.basic_data_Company"
      :method-params="methodParams"
      :headers="headers&&headers.length>0?headers:undefined"
      :fields="fields&&fields.length>0?fields:undefined"
      :tag-name="tagName"
      :style="customStyle"
      filterable
      :default-value="defaultValue"
      :placeholder="placeholder||undefined"
      :static-options="staticOptions"
      :data-filter-function="dataFilterFunction"
      :multiple="multiple"
      :default-multiple-value="defaultMultipleValue"
      :latest-used-data-key="latestUsedDataKey"
      @clear="$emit('clear')"
      @parentCallBack="onParentCallBack"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
    />
  </el-tooltip>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'

export default {
  name: 'CargoCompanySelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    dataFilterFunction: { type: Function, required: false }, // options项数据过滤函数
    methodParams: { type: Object, default: () => { return {} } },
    defaultValue: { type: [String, Number, Boolean], default: '' },
    headers: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    tagName: { type: String, default: '' },
    checkCredit: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    popperClass: { type: String, default: null },
    tooltip: { type: Boolean, default: false },
    tooltipTagName: { type: String, default: '' },
    staticOptions: { type: Array, default: null },
    customStyle: { type: String, default: '' },
    multiple: { type: Boolean, default: false },
    defaultMultipleValue: { type: [Array, String], default: () => { return [] } },
    job: { type: Object, required: false },
    latestUsedDataKey: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      tooltipContent: ''
    }
  },
  computed: {
    options() {
      return this.$refs.company ? this.$refs.company.options : []
    }
  },
  watch: {
    defaultValue: {
      handler(newVal) {
        if (!this.tooltip || !this.tooltipTagName) {
          return
        }
        if (newVal) {
          this.tooltipContent = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', newVal, this.tooltipTagName)
        } else {
          this.tooltipContent = ''
        }
      },
      immediate: true
    }
  },
  methods: {
    clear() {
      console.log('[ReleaseNumber] clear CargoCompanySelect')
      if (this.$refs.company && this.$refs.company.toClear) {
        this.$refs.company.toClear()
      } else {
        this.$emit('clear')
      }
    },
    async onParentCallBack(data) {
      // 信控验证
      if (data && this.checkCredit) {
        await cache.load(cacheName.CONFIG)
        if (parseInt(cache.config.get('creditOpen')) === 1) {
          const companyId = data.value
          await CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
            if (!res.data || res.data.length <= 0) return
            const credit = res.data[0]
            if (credit && credit.blacklist) {
              this.$message.warning(this.$t('Message.PartnersBeenAddedToBlacklist'))
              // showTip();
              return
            }
            for (const item of res.data) {
              this.setCreditColor(item)
            }
          })
        }
      }
      this.$emit('change', data)
    },
    setCreditColor(credit) {
      if (!credit) return
      if (credit.amountExceeded || credit.dateExceeded) {
        let s = ''
        if (credit.amountExceeded) { s += this.$t('Partners.credit_limit') + ' ' }
        if (credit.dateExceeded) { s += this.$t('Partners.accountPeriod') + ' ' }
        const toolTip = this.$t('Partners.parter') + ' ' + s + ' ' + this.$t('SeaExport.HasExceeded')
        this.$message.warning(toolTip)
        // showTip()
      }
    },
    showTip() {
      // var p:Point = new Point(width,5);
      // p = localToGlobal(p);
      // tool = ToolTipManager.createToolTip(toolTip,p.x,p.y);
      // if(tool) {
      //   setTimeout( function ():void {
      //     ToolTipManager.destroyToolTip(tool);
      //   },3000);
      // }
    }
  }
}
</script>

<style>
</style>
